import { Component, OnInit } from '@angular/core';
import { ModalLoginService } from '../../services/modal-login.service';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.css']
})
export class RegisterPageComponent implements OnInit {

  constructor(private modalLoginSrv: ModalLoginService) { }

  ngOnInit(): void {
    this.modalLoginSrv.openModalRegister();
  }

}
